import Parse from 'parse'
import PubNubVue from 'pubnub-vue'
// import moment from 'moment';

const state = {
  subscriptions: null,
  updateSubscriptions: null,
  userProfile: null,
  fetchList: null,
  messages: null,
  messageCount: null,
  channelGuys: null,
  sendMessage: null,
  notification: null,
  notificationSnapbar: false,
  chatUsers: null,
  globalChannel: null,
  pushNotification: null
}

const getters = {
  subscriptions: (state) => state.subscriptions,
  updateSubscriptions: (state) => state.updateSubscriptions,
  userProfile: (state) => state.userProfile,
  fetchList: (state) => state.fetchList,
  messages: (state) => state.messages,
  messageCount: (state) => state.messageCount,
  channelGuys: (state) => state.channelGuys,
  sendMessage: (state) => state.sendMessage,
  notification: (state) => state.notification,
  notificationSnapbar: (state) => state.notificationSnapbar,
  chatUsers: (state) => state.chatUsers,
  globalChannel: (state) => state.globalChannel,
  pushNotification: (state) => state.pushNotification
}

const actions = {
  async getSubscriptions ({ commit }, payload) {
    const Subscribe = Parse.Object.extend('Subscribes')
    const query = new Parse.Query(Subscribe)
    query.containedIn('users', [payload.id])
    query.descending('createdAt')
    query.limit(100)
    try {
      const result = await query.find()
      const channels = []
      if (result.length > 0) {
        for (var i = 0; i !== result.length; i++) {
          if (!isNaN(result[i].get('channel'))) {
            channels.push(result[i].get('channel'))
          }
        }
      }
      commit('setSubscriptions', channels)
    } catch (error) {
      console.log(error)
      commit('setSubscriptions', false)
    }
  },

  async getUpdateSubscriptions ({ commit }, payload) {
    const Subscribe = Parse.Object.extend('Subscribes')
    const query = new Parse.Query(Subscribe)
    query.containsAll('users', payload.users)
    query.limit(1)
    try {
      const result = await query.find()
      if (result.length === 0) {
        /** Save this record now */
        const saveSubscribe = await new Subscribe()
        saveSubscribe.set('users', payload.users)
        saveSubscribe.set('channel', payload.channel.toString())
        saveSubscribe.save(null, {
          success: function () {
            commit('setUpdateSubscriptions', true)
          },
          error: function (error) {
            console.log(error)
            commit('setUpdateSubscriptions', false)
          }
        })
      } else {
        commit('setUpdateSubscriptions', true)
      }
    } catch (error) {
      console.log(error)
      commit('setSubscriptions', false)
    }
  },

  async getUserProfile ({ commit }, payload) {
    const User = Parse.Object.extend('User')
    const query = new Parse.Query(User)
    query.equalTo('objectId', payload.userId)
    query.equalTo('status', true)
    try {
      const response = await query.first()
      commit('setUserProfile', response)
    } catch (error) {
      console.log(error)
      commit('setUserProfile', false)
    }
  },

  async getFetchList ({ commit }, payload) {
    const pubnub = PubNubVue.getInstance()
    await pubnub
      .fetchMessages({
        channels: payload.channels,
        count: 50,
        reverse: false
      })
      .then((response) => {
        commit('setFetchList', response)
      })
      .catch((error) => {
        console.log(error)
        commit('setFetchList', false)
      })
  },

  async getMessages ({ commit }, payload) {
    const pubnub = PubNubVue.getInstance()
    await pubnub
      .history({
        // search starting from this timetoken
        // start: payload.startToken,
        channel: payload.channel,
        // max: 100,
        // false - search forwards through the timeline
        // true - search backwards through the timeline
        reverse: payload.reverse,
        // limit number of messages per request to this value; default/max=100
        count: payload.pagesize,
        // include each returned message's publish timetoken
        includeTimetoken: true,
        // prevents JS from truncating 17 digit timetokens
        stringifiedTimeToken: true
      })
      .then((response) => {
        commit('setMessages', response)
      })
      .catch((error) => {
        console.log(error)
        commit('setMessages', false)
      })
  },

  async getMessageCount ({ commit }, payload) {
    const pubnub = PubNubVue.getInstance()
    /** messageCount api is not available for vue pubnub
    so getting unread count from message history using the end time */
    await pubnub
      .history({
        channel: payload.channel,
        reverse: false, // Setting to true will traverse the time line in reverse starting with the oldest message first.
        end: payload.lastTimeSlow // start timetoken to fetch
      })
      .then((response) => {
        commit('setMessageCount', response.messages.length)
      })
      .catch((error) => {
        console.log(error)
        commit('setMessageCount', false)
      })
  },

  async getChannelGuys ({ commit }, payload) {
    const Subscribes = Parse.Object.extend('Subscribes')
    const query = new Parse.Query(Subscribes)
    query.equalTo('channel', payload.channel)
    try {
      const response = await query.first()
      commit('setChannelGuys', response)
    } catch (error) {
      console.log(error)
      commit('setChannelGuys', false)
    }
  },

  async sendMessageNow ({ commit }, payload) {
    const pubnub = PubNubVue.getInstance()
    await pubnub
      .publish({
        message: {
          text: payload.message,
          senderId: payload.senderId,
          receiverId: payload.receiverId,
          senderName: payload.senderName,
          senderProfilePic: payload.senderProfilePic
        },
        channel: payload.channel
      })
      .then((response) => {
        commit(
          'setSendMessage',
          'message Published w/ timetoken',
          response.timetoken
        )
      })
      .catch((error) => {
        console.log(error)
        commit('setSendMessage', false)
      })
  },

  async sendPushNotification ({ commit }, payload) {
    const data = {
      include_player_ids: payload.player_id,
      message: payload.message,
      type: payload.type,
      senderId: payload.senderId,
      heading: payload.name,
      android_group: payload.type,
      thread_id: payload.type
    }
    Parse.Cloud.run('sendPush', data).then(
      (results) => {
        console.log(results)
        commit('setPushNotification', true)
      },
      (error) => {
        console.log(error)
        commit('setPushNotification', false)
      }
    )
  },

  async getNotificationSnapbar ({ commit }, payload) {
    commit('setNotification', payload.notification)
    commit('setNotificationSnapbar', payload.state)
  },

  async getChannel ({ commit }, payload) {
    commit('setChannel', payload.channel)
  }
}

const mutations = {
  setSubscriptions: (state, subscriptions) =>
    (state.subscriptions = subscriptions),
  setUpdateSubscriptions: (state, updateSubscriptions) =>
    (state.updateSubscriptions = updateSubscriptions),
  setUserProfile: (state, userProfile) => (state.userProfile = userProfile),
  setFetchList: (state, fetchList) => (state.fetchList = fetchList),
  setMessages: (state, messages) => (state.messages = messages),
  setMessageCount: (state, messageCount) => (state.messageCount = messageCount),
  setChannelGuys: (state, channelGuys) => (state.channelGuys = channelGuys),
  setSendMessage: (state, sendMessage) => (state.sendMessage = sendMessage),
  setNotificationSnapbar: (state, notificationSnapbar) =>
    (state.notificationSnapbar = notificationSnapbar),
  setNotification: (state, notification) => (state.notification = notification),
  setChannel: (state, globalChannel) => (state.globalChannel = globalChannel),
  setPushNotification: (state, pushNotification) =>
    (state.pushNotification = pushNotification)
}

export default {
  state,
  getters,
  actions,
  mutations
}
